import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  padding = 'md',
  shadow = true,
  ...props 
}) => {
  const baseClasses = 'bg-[#0b1120] rounded-2xl border border-white/5 text-gray-100';
  
  const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-4 sm:p-6',
    lg: 'p-4 sm:p-6 md:p-8',
    xl: 'p-4 sm:p-6 md:p-8 lg:p-10'
  };
  
  const shadowClass = shadow ? 'transition-all duration-200' : '';
  
  const classes = `${baseClasses} ${paddingClasses[padding]} ${shadowClass} ${className}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`mb-4 ${className}`} {...props}>
    {children}
  </div>
);

const CardTitle = ({ children, className = '', ...props }) => (
  <h3 className={`text-lg md:text-xl font-semibold text-white ${className}`} {...props}>
    {children}
  </h3>
);

const CardDescription = ({ children, className = '', ...props }) => (
  <p className={`text-sm text-gray-400 ${className}`} {...props}>
    {children}
  </p>
);

const CardContent = ({ children, className = '', ...props }) => (
  <div className={className} {...props}>
    {children}
  </div>
);

const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`mt-4 pt-4 border-t border-white/5 ${className}`} {...props}>
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Description = CardDescription;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
